import React, { FC, useState } from 'react';

import connector, { PropsFromRedux } from '@app/utils/store';
import { Empty } from '@ui';
import useTranslation from '@app/hooks/use-translation';

import { MonitoringRecordDataType } from '@app/interfaces/qm-module/qm-manage/qm-monioring-tasks.type';

import { useGetGptGroupsWithMetricsQuery } from '@app/store/api/gpt-metric.api';

import { usePermissionCheck } from '@app/hooks/use-permission';

import { userPermissions } from '@app/utils/user-permissions';

import { useGetChatGptGroupsWithMetricsQuery } from '@app/store/api/chat-api/gpt-metric-chat.api';

import AudioContainer from './audio-container';
import audioContextProvider from './record-provider';

type AudioBuildProps = {
  recordId: string;
  projectId?: string;
  appeal_id?: string;
  withMetric?: boolean;
  appealResolveMode?: boolean;
  recordMfId?: string;
  currentTemplate: 'chat' | 'voice';
  recordMonitoring?: {
    recordMonitoringData: MonitoringRecordDataType | undefined;
    recordMonitoringLoading: boolean;
  };
} & PropsFromRedux;

const AudioBuild: FC<AudioBuildProps> = (props) => {
  const {
    recordId,
    projectId,
    withMetric = false,
    currentTemplate,
    appealResolveMode,
    recordMfId,
    appeal_id,
    recordMonitoring,
  } = props;

  const gptGptGroupMetricsAccess = usePermissionCheck({
    permissions: 'action',
    tag: userPermissions.action.actionGetGPTGroupMetrics,
  });
  const { data: gptVoiceGroupsList } = useGetGptGroupsWithMetricsQuery(
    { params: { project_id: projectId || '' } },
    { skip: !!gptGptGroupMetricsAccess || !projectId },
  );
  const { data: gptChatGroupsList } = useGetChatGptGroupsWithMetricsQuery(
    { params: { project_id: projectId || '' } },
    { skip: !!gptGptGroupMetricsAccess || !projectId },
  );
  const gptGroupsList = { chat: gptChatGroupsList, voice: gptVoiceGroupsList }[
    currentTemplate || 'voice'
  ];
  const [toggleEmotions, changeToggleEmotions] = useState<boolean>(false);
  const { t } = useTranslation('components.audio');
  const contextState = {
    withMetric,
    projectId,
    recordId,
    toggleEmotions,
    appeal_id,
    currentTemplate,
    appealResolveMode,
    changeToggleEmotions,
    recordMfId,
    recordMonitoring,
    gptGroupsList,
  };

  if (!recordId) {
    return (
      <>
        <Empty title={t('record_not_found')} />
      </>
    );
  }

  return (
    <audioContextProvider.Provider value={contextState}>
      <AudioContainer />
    </audioContextProvider.Provider>
  );
};

export default connector(AudioBuild);
